module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#video",
      toString: function () {
        return this.url;
      }
    }